import { useMutation, useQuery } from '@tanstack/react-query';
import { bookingPublicApi } from '../api/bookingPublicApi';
import { CreateBookingDto } from '../types/booking';

const QUERY_OPTIONS = {
  refetchOnWindowFocus: false,
  refetchOnReconnect: false,
  retry: false,
} as const;

export const usePublicServices = (bookingSlug: string) =>
  useQuery({
    queryKey: ['public-booking-services', bookingSlug],
    queryFn: () => bookingPublicApi.getServices(bookingSlug).then((res) => res.data),
    enabled: Boolean(bookingSlug),
    ...QUERY_OPTIONS,
  });

export const usePublicBookingSettings = (bookingSlug: string) =>
  useQuery({
    queryKey: ['public-booking-settings', bookingSlug],
    queryFn: () => bookingPublicApi.getSettings(bookingSlug).then((res) => res.data),
    enabled: Boolean(bookingSlug),
    ...QUERY_OPTIONS,
  });

export const usePublicAvailability = (
  bookingSlug: string,
  serviceId: string,
  startDate: string,
  endDate: string
) =>
  useQuery({
    queryKey: [
      'public-booking-availability',
      bookingSlug,
      serviceId,
      startDate,
      endDate,
    ],
    queryFn: () =>
      bookingPublicApi
        .getAvailability(
          bookingSlug,
          serviceId,
          startDate,
          endDate
        )
        .then((res) => res.data),
    enabled: Boolean(
      bookingSlug &&
      serviceId &&
      startDate &&
      endDate
    ),
    ...QUERY_OPTIONS,
  });

export const useCreatePublicBooking = () =>
  useMutation({
    mutationFn: (data: CreateBookingDto) => bookingPublicApi.createBooking(data).then((res) => res.data),
  });

